import React from 'react';
import {IconProps} from './typing';

const External = ({iconSize}: IconProps) => (
  <svg
    width={iconSize}
    height={iconSize}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.7444 0.241501C11.4339 -0.0639987 11.3804 -0.0809987 6.27738 0.199001L6.36938 1.894C7.50338 1.8325 8.37938 1.725 9.08288 1.699L3.81738 6.933L5.01638 8.137L10.2809 2.8885C10.2504 3.5585 10.1484 4.4695 10.0789 5.5905L11.7759 5.6955C12.0874 0.665501 12.0714 0.577001 11.7444 0.241501Z"
      fill="#001E50"
    />
    <path
      d="M9.8 7.507H11.499V12H0V0.5H4.5V2.1975H1.6995V10.3025H9.8V7.507Z"
      fill="#001E50"
    />
  </svg>
);

export default External;
